package com.upcominds.expedite.di

import com.upcominds.expedite.data.NetworkClient
import com.upcominds.expedite.data.achievements.AchievementsRepository
import com.upcominds.expedite.data.achievements.AchievementsRepositoryImpl
import com.upcominds.expedite.data.admin.AdminRepository
import com.upcominds.expedite.data.admin.AdminRepositoryImpl
import com.upcominds.expedite.data.auth.AuthConfigProvider
import com.upcominds.expedite.data.auth.AuthRepository
import com.upcominds.expedite.data.challenges.ChallengesRepository
import com.upcominds.expedite.data.challenges.ChallengesRepositoryImpl
import com.upcominds.expedite.data.communities.CommunitiesRepository
import com.upcominds.expedite.data.communities.CommunitiesRepositoryImpl
import com.upcominds.expedite.data.leaders.LeadersRepository
import com.upcominds.expedite.data.leaders.LeadersRepositoryImpl
import com.upcominds.expedite.data.mobilelogs.MobileLogService
import com.upcominds.expedite.data.news.NewsRepository
import com.upcominds.expedite.data.news.NewsRepositoryImpl
import com.upcominds.expedite.data.rewards.RewardsRepository
import com.upcominds.expedite.data.rewards.RewardsRepositoryImpl
import com.upcominds.expedite.data.user.UserRepository
import com.upcominds.expedite.data.user.UserRepositoryImpl
import com.upcominds.expedite.features.challenges.ChallengesViewModel
import com.upcominds.expedite.features.achievements.AchievementsViewModel
import com.upcominds.expedite.features.challenges.SavingsChallengeViewModel
import com.upcominds.expedite.features.challenges.SocialChallengeViewModel
import com.upcominds.expedite.features.community.CommunityViewModel
import com.upcominds.expedite.features.leaders.LeadersViewModel
import com.upcominds.expedite.features.news.NewsViewModel
import com.upcominds.expedite.features.rewards.RewardsViewModel
import com.upcominds.expedite.features.profile.ProfileViewModel
import com.upcominds.expedite.features.signIn.SignInViewModel
import com.upcominds.expedite.features.signUp.SignUpViewModel
import com.upcominds.expedite.features.quiz.QuizViewModel
import com.upcominds.expedite.features.puzzle.PuzzleViewModel
import com.upcominds.expedite.features.splash.SplashViewModel
import com.upcominds.expedite.features.dashboard.DashboardViewModel
import io.ktor.client.HttpClient
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import org.koin.core.module.Module
import org.koin.dsl.module

import org.koin.core.qualifier.named

val sharedModule: Module = module {

    // A separate HttpClient for auth operations, without the Auth plugin
    single(named("AuthHttpClient")) {
        HttpClient {
            install(HttpTimeout) { requestTimeoutMillis = 15_000; connectTimeoutMillis = 10_000; socketTimeoutMillis = 15_000 }
            install(ContentNegotiation) {
                json(Json {
                    ignoreUnknownKeys = true
                    useAlternativeNames = false
                })
            }
        }
    }

    single { NetworkClient.httpClient }

    // AuthRepository depends on platform-provided TokenStorage and OidcAuthPlatform
    single { AuthRepository(get(), get(), AuthConfigProvider.oidcConfig, get(named("AuthHttpClient"))) }

    single<AchievementsRepository> { AchievementsRepositoryImpl() }
    single<UserRepository> { UserRepositoryImpl() }
    single<ChallengesRepository> { ChallengesRepositoryImpl() }
    single<CommunitiesRepository> { CommunitiesRepositoryImpl() }
    single<LeadersRepository> { LeadersRepositoryImpl() }
    single<NewsRepository> { NewsRepositoryImpl() }
    single<RewardsRepository> { RewardsRepositoryImpl() }
    single<AdminRepository> { AdminRepositoryImpl() }
    single { com.upcominds.expedite.data.energy.CommunityEnergyRepository() }
    single { com.upcominds.expedite.features.energy.CommunityEnergyViewModel(get()) }
    single { MobileLogService() }

    single { AchievementsViewModel(get()) }
    single { ChallengesViewModel(get(), get()) }
    single { SavingsChallengeViewModel(get(), get()) }
    single { SocialChallengeViewModel(get(), get()) }
    single { LeadersViewModel(get(), get()) }
    single { CommunityViewModel(get()) }
    single { NewsViewModel(get()) }
    single { RewardsViewModel(get()) }
    single { ProfileViewModel(get()) }
    single { SignInViewModel(get()) }
    single { SignUpViewModel(get()) }
    single { QuizViewModel(get()) }
    single { PuzzleViewModel(get()) }

    // Splash viewmodel uses AuthRepository
    single { SplashViewModel(get()) }

    // Injecting AdminRepository (get()) and real ChallengesRepository (get())
    single { DashboardViewModel(get(), get()) }
}
